/**
 * Build edition — "saas" (default) or "onprem".
 *
 * Chosen at BUILD time:   VITE_EDITION=onprem npm run build
 *
 * The value is inlined by Vite, so every `IS_ONPREM ? … : …` below is decided
 * while bundling: pages that do not exist on-prem (groups, organizations,
 * platform settings and the placeholder screens) are not just hidden — their
 * code is left out of the on-prem bundle entirely. A SaaS build (no
 * VITE_EDITION) is byte-for-byte the same product as before.
 */
export const EDITION: "saas" | "onprem" =
  import.meta.env.VITE_EDITION === "onprem" ? "onprem" : "saas";

export const IS_ONPREM = import.meta.env.VITE_EDITION === "onprem";

/** Nav/route ids that do not exist in the on-prem edition. */
export const ONPREM_REMOVED_PAGES: ReadonlySet<string> = new Set([
  "groups",              // Group Management (platform)
  "organizations",       // Organization CRUD (group)
  "group-dashboard",     // Group Dashboard (group, placeholder)
  "org-dashboard",       // Organization Dashboard (placeholder)
  "resource-monitoring", // placeholder; live metrics are in System Monitoring
  "mitre-attack",        // placeholder
  "settings",            // platform settings (labels, limits)
]);
